"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualTable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_virtuoso_1 = require("react-virtuoso");
var react_table_1 = require("react-table");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var antd_1 = require("antd");
var use_deep_compare_effect_1 = tslib_1.__importDefault(require("use-deep-compare-effect"));
var lodash_1 = require("lodash");
var column_sort_1 = tslib_1.__importDefault(require("./components/filter/column-sort"));
var debounce_1 = require("./hooks/debounce");
var Styles = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .table {\n    display: inline-block;\n    .table-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n    .tr > .td {\n      padding: 12px 1.2px 12px 8px;\n    }\n\n    .even {\n      background: rgb(249, 251, 253);\n    }\n\n    .odd {\n      background: #eef2f8;\n    }\n\n    .table-row-header {\n      background: #eef2f8;\n    }\n\n    .th {\n      background: #eef2f8;\n      border-top: 1px solid rgb(217, 227, 240);\n      border-bottom: 1px solid rgb(217, 227, 240);\n      font-weight: 500;\n      height: 40px !important;\n    }\n  }\n\n  tr {\n    border-top: 1px solid rgb(217, 227, 240);\n    :nth-child(1) {\n      border-top: none;\n    }\n  }\n  .table-header {\n    text-align: left;\n  }\n\n  .fixed-colum {\n    border-right: 1px solid rgb(217, 227, 240);\n  }\n"], ["\n  .table {\n    display: inline-block;\n    .table-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n    .tr > .td {\n      padding: 12px 1.2px 12px 8px;\n    }\n\n    .even {\n      background: rgb(249, 251, 253);\n    }\n\n    .odd {\n      background: #eef2f8;\n    }\n\n    .table-row-header {\n      background: #eef2f8;\n    }\n\n    .th {\n      background: #eef2f8;\n      border-top: 1px solid rgb(217, 227, 240);\n      border-bottom: 1px solid rgb(217, 227, 240);\n      font-weight: 500;\n      height: 40px !important;\n    }\n  }\n\n  tr {\n    border-top: 1px solid rgb(217, 227, 240);\n    :nth-child(1) {\n      border-top: none;\n    }\n  }\n  .table-header {\n    text-align: left;\n  }\n\n  .fixed-colum {\n    border-right: 1px solid rgb(217, 227, 240);\n  }\n"])));
var stickyColumnHeader = {
    position: "sticky",
    left: 0,
    textAlign: "left",
};
var ColumnHeader = (0, styled_components_1.default)(antd_1.Typography.Text)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-size: 14px !important;\n"], ["\n  font-size: 14px !important;\n"])));
var ColumnResizerControl = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  height: 20px;\n  width: 5px;\n\n  :hover {\n    background: #9a39fb;\n  }\n"], ["\n  height: 20px;\n  width: 5px;\n\n  :hover {\n    background: #9a39fb;\n  }\n"])));
var ResizeContainer = (0, styled_components_1.default)(antd_1.Col)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: end;\n  margin-left: 4px;\n"], ["\n  display: flex;\n  justify-content: end;\n  margin-left: 4px;\n"])));
var scrollbarWidth = function () {
    var scrollDiv = document.createElement("div");
    scrollDiv.setAttribute("style", "width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;");
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
};
function Table(_a) {
    var _b = _a.defaultColumWidth, defaultColumWidth = _b === void 0 ? 200 : _b, columns = _a.columns, data = _a.data, height = _a.height, loadMore = _a.loadMore, hasMore = _a.hasMore, onClickRow = _a.onClickRow, sortable = _a.sortable, onReSizeColumn = _a.onReSizeColumn;
    var _c = (0, react_1.useState)(columns), tableColumns = _c[0], setTableColumns = _c[1];
    var ref = (0, react_1.useRef)(null);
    var scrollBarSize = (0, react_1.useMemo)(function () { return scrollbarWidth(); }, []);
    var _d = (0, react_table_1.useTable)({
        columns: tableColumns,
        data: data,
    }, react_table_1.useBlockLayout, react_table_1.useResizeColumns), getTableProps = _d.getTableProps, getTableBodyProps = _d.getTableBodyProps, headerGroups = _d.headerGroups, rows = _d.rows, prepareRow = _d.prepareRow, state = _d.state;
    var tableBody = (0, react_1.forwardRef)(function (_a, ref) {
        var props = tslib_1.__rest(_a, []);
        return (react_1.default.createElement("tbody", tslib_1.__assign({}, getTableBodyProps(), props, { ref: ref, className: 'table-row-header' })));
    });
    tableBody.displayName = "TableBody";
    var columnChanges = columns.map(function (c) {
        return { width: c.width };
    });
    (0, react_1.useEffect)(function () {
        var _a;
        var tableWidth = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        var sumColumns = columns.reduce(function (acc, curr) { return acc + curr.width; }, 0);
        var columnWithoutWidthsLength = columns.filter(function (column) { return column.width === 0; }).length;
        var columnWidth = (tableWidth - sumColumns) / columnWithoutWidthsLength;
        var modifiedColumns = columns.map(function (column) {
            var width = column.width || columnWidth;
            return tslib_1.__assign(tslib_1.__assign({}, column), { width: Number(width) < defaultColumWidth ? defaultColumWidth : width });
        });
        setTableColumns(tslib_1.__spreadArray([], modifiedColumns, true));
    }, [columns]);
    (0, use_deep_compare_effect_1.default)(function () {
        var _a;
        var tableWidth = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        var sumColumns = columns.reduce(function (acc, curr) { return acc + curr.width; }, 0);
        var columnsWidth = sumColumns + scrollBarSize;
        var columnWithoutWidthsLength = columns.filter(function (column) { return column.width === 0; }).length;
        var columnWidth = (tableWidth - sumColumns) / columnWithoutWidthsLength;
        if (tableWidth > columnsWidth && !(0, lodash_1.isEmpty)(columns)) {
            if (tableWidth - columnsWidth > 0) {
                var modifiedColumns = columns.map(function (column) {
                    var width = column.width || columnWidth;
                    if (column.width === 0 && Number(width) < defaultColumWidth) {
                        width = defaultColumWidth;
                    }
                    return tslib_1.__assign(tslib_1.__assign({}, column), { width: width });
                });
                setTableColumns(tslib_1.__spreadArray([], modifiedColumns, true));
            }
        }
    }, [{ columns: columnChanges }]);
    var debouncedState = (0, debounce_1.useDebounce)(state, 500);
    (0, use_deep_compare_effect_1.default)(function () {
        // @ts-ignore
        var _a = state === null || state === void 0 ? void 0 : state.columnResizing, columnWidths = _a.columnWidths, isResizingColumn = _a.isResizingColumn;
        if (columnWidths && onReSizeColumn && !isResizingColumn) {
            Object.keys(columnWidths).map(function (key) {
                onReSizeColumn(key, columnWidths[key]);
            });
        }
    }, [{ state: debouncedState }]);
    return (react_1.default.createElement(Styles, { ref: ref },
        react_1.default.createElement(react_virtuoso_1.TableVirtuoso, { style: { height: height }, totalCount: rows.length, endReached: function () {
                if (hasMore && loadMore) {
                    loadMore();
                }
            }, components: {
                Table: function (_a) {
                    var props = tslib_1.__rest(_a, []);
                    return (react_1.default.createElement("table", tslib_1.__assign({}, getTableProps(), props, { className: 'table', style: { width: "100%", tableLayout: "fixed" } })));
                },
                // @ts-ignore
                TableBody: tableBody,
                TableRow: function (props, i) {
                    var index = props["data-index"];
                    var row = rows[index];
                    return (react_1.default.createElement("tr", tslib_1.__assign({}, props, row.getRowProps(), { key: i, className: "tr row-data ".concat(index % 2 === 0 ? "even" : "odd"), onClick: function (e) {
                            var cellText = document.getSelection();
                            if ((cellText === null || cellText === void 0 ? void 0 : cellText.type) === "Range") {
                                e.stopPropagation();
                                return;
                            }
                            if (onClickRow) {
                                onClickRow(row.original);
                            }
                        } })));
                },
            }, fixedHeaderContent: function () {
                return headerGroups.map(function (headerGroup, i) { return (react_1.default.createElement("tr", tslib_1.__assign({}, headerGroup.getHeaderGroupProps(), { key: i, className: 'tr' }), headerGroup.headers.map(function (column, j) {
                    var fixed = column.fixed;
                    var width = { width: column.width };
                    var style = fixed ? tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, stickyColumnHeader), width), { zIndex: 1 }) : width;
                    return (react_1.default.createElement("th", tslib_1.__assign({}, column.getHeaderProps(), { key: j, className: "th table-header", style: style }),
                        react_1.default.createElement(ColumnHeader, { ellipsis: { tooltip: column === null || column === void 0 ? void 0 : column.tooltip }, strong: true, className: "column-headers" }, column.render("Header")),
                        ((sortable === "multiple" && column.sortable === true) || column.resizable !== false) && (react_1.default.createElement(antd_1.Row, { align: "middle", justify: "end", style: { minWidth: "25px" } },
                            sortable === "multiple" && column.sortable === true && (react_1.default.createElement(antd_1.Col, { span: 18 },
                                react_1.default.createElement(column_sort_1.default, { columnId: column.id }))),
                            column.resizable !== false && (react_1.default.createElement(ResizeContainer, { span: 2 },
                                react_1.default.createElement(ColumnResizerControl, tslib_1.__assign({ className: 'column-resizer' }, column === null || column === void 0 ? void 0 : column.getResizerProps()))))))));
                }))); });
            }, itemContent: function (index) {
                var row = rows[index];
                prepareRow(row);
                return row.cells.map(function (cell, i) {
                    var fixed = cell.column.fixed;
                    var width = { width: cell.column.width };
                    var style = fixed ? tslib_1.__assign(tslib_1.__assign({}, stickyColumnHeader), width) : width;
                    return (react_1.default.createElement("td", tslib_1.__assign({}, cell.getCellProps(), { key: i, className: "td ".concat(index % 2 === 0 ? "even" : "odd", " ").concat(fixed ? "fixed-colum" : ""), style: style }), cell.render("Cell")));
                });
            } })));
}
var VirtualTable = function (_a) {
    var props = tslib_1.__rest(_a, []);
    var defaultColumWidth = props.defaultColumWidth, columns = props.columns, dataSource = props.dataSource, originalRecords = props.originalRecords, height = props.height;
    var records = [];
    dataSource.forEach(function (data, i) {
        var res = tslib_1.__assign({}, data);
        var original = originalRecords ? originalRecords[i] : {};
        columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
            if (column.render && originalRecords) {
                res[column.accessor] = column.render(original);
            }
            else {
                res[column.accessor] = data[column.accessor];
            }
        });
        records.push(res);
    });
    return (react_1.default.createElement(antd_1.Spin, { spinning: props.loading },
        react_1.default.createElement(Table, { defaultColumWidth: defaultColumWidth, columns: columns, data: records, height: height || 550, loading: props.loading, loadMore: props.onPaginate, hasMore: props.hasMore, onClickRow: props.onClickRow, sortable: props.sortable, onReSizeColumn: props.onReSizeColumn })));
};
exports.VirtualTable = VirtualTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=virtual-table.js.map